import { Trans } from 'react-i18next'

import { IActionFormProps } from '@makyoapp/makyo-common'
import { Button, ButtonVariant, Field, Label } from '@makyoapp/makyo-ui'

import { useForm } from '@/lib/use-form'
import { ActionInputdata } from '@/shared/action.types'
import { ActionInputV2 } from '@/components/ActionInputV2'

/**
 * @todo
 */
export default function ActFormPushNotif({ onSubmit, onDismiss, initialData }: IActionFormProps) {
  const { form, onSubmit: onFormSubmit } = useForm<ActionInputdata>({
    defaultValues: {
      ...((initialData || {}) as ActionInputdata),
    },
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  return (
    <div>
      <div className='p-4'>
        <Field>
          <Label>Select Column</Label>
          <ActionInputV2
            value={form.getValues()}
            onChange={(values) => {
              form.setValues(() => values)
            }}
            error={form.errors?.value}
          />
        </Field>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  )
}
